<template>
  <div>
    <h1>Wrsitband Page</h1>
  </div>
</template>

<script>

export default {

  created() {
    window.location.href = "https://activation.frontgatetickets.com/#/2021outsidelands";
  },

};
</script>